import { type ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { SessionGuard } from '@app/components/SessionGuard';

import { readAuthSnapshot } from './authGate';

export function RequireAuth(): ReactElement {
  const location = useLocation();
  const snapshot = readAuthSnapshot();

  if (snapshot.user === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <>
      <SessionGuard />
      <Outlet />
    </>
  );
}
